import { Container, Image, InnerContainer, OuterContainer } from './styled.ts';
import { type Props } from './types.ts';

export const ProfileImage = ({ name, src }: Props) => (
  <OuterContainer>
    <Container>
      <InnerContainer>
        <picture>
          <Image alt={name} loading="lazy" src={src} />
        </picture>
      </InnerContainer>
    </Container>
  </OuterContainer>
);
